import React from "react";
import CategoryBar from "./CategoryBar";

const CategoryBuilder = () => {
  return (
      <CategoryBar/>
  );
};
export default CategoryBuilder;
